<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle></PageTitle>
        <b-card>
          <b-row>
            <b-col sm="6">
              <b-form-group>
                <label>{{ $t('page.generic.code') }} <required-field /></label>
                <b-form-input aria-describedby="codeField" :state="errors.some((e) => e.field === 'code')?false:null"
                              type="text" id="code" v-model="documentType.code" aria-required="true"
                              :required=true></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <label>{{ $t('page.generic.name') }} <required-field /></label>
                <b-form-input aria-describedby="labelField" :state="errors.some((e) => e.field === 'label')?false:null"
                              type="text" id="label" v-model="documentType.label" aria-required="true"
                              :required=true></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group>
                <label>{{ $t('page.generic.description') }}</label>
                <b-form-textarea aria-describedby="descriptionField" :state="errors.some((e) => e.field === 'description')?false:null"
                                 type="text" id="description" v-model="documentType.description"></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group>
                <label for="documentTypeCodingSchema">{{ $t('title.codingSchema') }} <required-field /></label>
                <v-select :class="errors.some((e) => e.field === 'documentTypeCodingSchema') ? 'error' :''" id="documentTypeCodingSchema" :options="options"
                          v-model="documentType.documentTypeCodingSchema"
                          @search="onSearch">
                  <template slot="no-options">
                    scrivi per cercare il coding schema..
                  </template>
                  <template slot="selected-option" slot-scope="option">
                    <div class="d-flex w-100 justify-content-between">
                      <h5 class="mb-1">{{option.label}}</h5>
                      <small class="ml-3">({{ option.code }} - v.{{option.codingSchemaVersion}})</small>
                    </div>
                  </template>
                  <template slot="option" slot-scope="option">
                    <div class="d-flex w-100 justify-content-between">
                      <h5 class="mb-1">{{option.label}}</h5>
                      <small>({{ option.code }} - v.{{option.codingSchemaVersion}})</small>
                    </div>
                  </template>
                </v-select>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <button class="btn btn-success float-right padder" type="button" @click="createDocumentType">
                {{ $t('actions.save') }}
              </button>
              <router-link class="btn btn-primary float-right" role="button" :to="{name: 'doctypeRoute'}">
                {{ $t('actions.abort') }}
              </router-link>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import miniToastr from 'mini-toastr' //ES6
  import PageTitle from '@/components/PageTitle'
  import CodingSchemaService from '@/services/CodingSchemaService'
  import DocumentTypeService from '@/services/DocumentTypeService'
  import vSelect from 'vue-select'
  import {_} from 'vue-underscore';
  import RequiredField from "../../components/RequiredField";

  const documentTypeService = DocumentTypeService.build();
  const codingSchemaService = CodingSchemaService.build();

  export default {
    name: 'documentTypeNew',
    inheritAttrs: false,
    components: {
      RequiredField,
      PageTitle,
      vSelect
    },
    props: {
      id: {
        required: true
      }
    },
    data() {
      return {
        documentType: {},
        errors: [],
        options: []
      }
    },
    created() {
      miniToastr.init(); // config can be passed here miniToastr.init(config)
      miniToastr.setIcon('error', 'i', {'class': 'fas fa-exclamation-triangle'});
      this.fetchData()
    },
    methods: {
      async createDocumentType() {
        try {
          let newDocumentType = await documentTypeService.create(this.documentType);
          this.$router.push({name: 'doctypeShowRoute', params: {id: newDocumentType.id}});
          miniToastr.info("Document Type creata con successo");
        } catch (exception) {
          this.errors = exception.errors;
          exception.errors.forEach(function (element) {
            miniToastr.error(element.message);
          });
        }

      },
      onSearch(search, loading) {
        loading(true);
        this.search(loading, search, this);
      },
      search: _.debounce(async (loading, search, vm) => {
        try {
          let result = await codingSchemaService.search({});
          vm.options = result.data || [];
        } catch (exception) {
          miniToastr.error(exception.message);
        }
        loading(false);
      }, 350)

    }
  }
</script>

